import { DatePipe } from "@angular/common";

export class TransactionFilter {
    clientEmail: string;
    applicationId: string;
    success: Boolean;
    cnpCui: string;
    serialNo: string;
    startDate: Date;
    endDate: Date;
    pageNumber: number;
    itemPerPage: number;

    toQueryString(): string {
        const queryParams = new URLSearchParams();
        if(!!this.clientEmail){
            queryParams.set('clientEmail', this.clientEmail);
        }
        if(!!this.applicationId){
            queryParams.set('applicationId', this.applicationId);
        }
        if(this.success != null || this.success != undefined){
            queryParams.set('success', this.success.toString());
        }
        if(!!this.cnpCui){
            queryParams.set('cnpCui', this.cnpCui);
        }
        if(!!this.serialNo){
            queryParams.set('serialNo', this.serialNo);
        }
        if(!!this.startDate){
            queryParams.set('startDate', this.formatDate(this.startDate));
        }
        if(!!this.endDate){
            queryParams.set('endDate', this.formatDate(this.endDate));
        }
        if(!!this.serialNo){
            queryParams.set('serialNo', this.serialNo);
        }
        if(!!this.pageNumber){
            queryParams.set('pageNumber', this.pageNumber.toString());
        }
        if(!!this.itemPerPage){
            queryParams.set('itemPerPage', this.itemPerPage.toString());
        }
        return queryParams.toString();
    }

    private formatDate(date: Date): string {
        const datePipe = new DatePipe('en-US');
        return datePipe.transform(date, 'yyyy-MM-dd');
      }
}